"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.entries = entries;
function entries(object) {
    return Object.entries(object);
}
